import getBaseTheme from './get-base-theme';

export default getBaseTheme;
